import * as React from 'react';

var EMPTY_FINGERPRINT = Promise.resolve("");
/**
 * Default no-op context value
 *
 * It is used as fallback when no provider (e.g. in NodeJS runtime or when SEON
 * is disabled) is given and lets hooks to continue function properly.
 *
 * @const
 *
 * @access private
 */

var DEFAULT_CONTEXT_VALUE = {
  resolveFingerprint() {
    return EMPTY_FINGERPRINT;
  }

};
/**
 * React Context for SEON
 *
 * @type {React.Context}
 *
 * @access private
 */

var SeonContext = /*#__PURE__*/React.createContext(DEFAULT_CONTEXT_VALUE);

export { SeonContext };
